import { render, staticRenderFns } from "./DisplayFiles.vue?vue&type=template&id=41fb02b5"
import script from "./DisplayFiles.vue?vue&type=script&lang=js"
export * from "./DisplayFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports